"use strict";

exports.__esModule = true;
exports["default"] = exports.ResultItemBottomBorderStyle = exports.ResultContainer = exports.ProductType = exports.ProductTitle = exports.ProductInfo = exports.ProductDate = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _downloadLinks = _interopRequireWildcard(require("../download-links"));

var _excluded = ["image"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ResultItemBottomBorderStyle = (0, _styledComponents.css)(["border-bottom:1px solid ", ";"], function (props) {
  return (0, _styles.colors)("gray", props);
});
exports.ResultItemBottomBorderStyle = ResultItemBottomBorderStyle;
var ResultContainer = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "document-item__ResultContainer",
  componentId: "sc-mzl0sk-0"
})(["display:grid;column-gap:16px;row-gap:8px;border-top:1px solid ", ";border-radius:0;box-shadow:none;text-decoration:none;", " &:hover{border-color:#fff;box-shadow:2px 4px 20px 0 rgba(0,0,0,0.1);border-radius:10px;}"], function (props) {
  return (0, _styles.colors)("gray", props);
}, (0, _styles.transitionEase)("0.2s", ["box-shadow", "border-color", "border-radius"]));
exports.ResultContainer = ResultContainer;
var ProductTitle = (0, _styledComponents["default"])(function (_ref) {
  var image = _ref.image,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, rest);
}).withConfig({
  displayName: "document-item__ProductTitle",
  componentId: "sc-mzl0sk-1"
})(["align-self:center;grid-column:1;grid-row:1;@media (max-width:549px){grid-row:2;}"]);
exports.ProductTitle = ProductTitle;
var ProductInfo = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "document-item__ProductInfo",
  componentId: "sc-mzl0sk-2"
})(["grid-column:1;grid-row:2;@media (max-width:549px){grid-row:3;}"]);
exports.ProductInfo = ProductInfo;
var ProductDate = (0, _styledComponents["default"])(function (_ref2) {
  var props = Object.assign({}, _ref2);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, props);
}).withConfig({
  displayName: "document-item__ProductDate",
  componentId: "sc-mzl0sk-3"
})(["text-align:right;grid-column:2;grid-row:1 / span 2;"]);
exports.ProductDate = ProductDate;
var ProductType = (0, _styledComponents["default"])(ProductDate).withConfig({
  displayName: "document-item__ProductType",
  componentId: "sc-mzl0sk-4"
})(["text-transform:uppercase;cursor:pointer;grid-column:1;"]);
exports.ProductType = ProductType;
var OverflowBox = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "document-item__OverflowBox",
  componentId: "sc-mzl0sk-5"
})(["overflow-x:auto;overflow-y:hidden;"]);
var propTypes = {
  /** Formatted date */
  date: _propTypes.string,

  /** Default onClick function for each download option */
  downloadAction: _propTypes.func,

  /** An array of download option objects, optionOnClick overrides downloadAction */
  downloadOptions: (0, _propTypes.arrayOf)(_downloadLinks.downloadOptionPropType),

  /** Text for download links group */
  downloadText: _propTypes.string,

  /** Title for the result document */
  title: _propTypes.string.isRequired
};

var ResultItem = function ResultItem(_ref3) {
  var date = _ref3.date,
      downloadAction = _ref3.downloadAction,
      downloadOptions = _ref3.downloadOptions,
      downloadText = _ref3.downloadText,
      title = _ref3.title;
  return /*#__PURE__*/_react["default"].createElement(ResultContainer, {
    forwardedAs: "section",
    px: 2,
    py: 3
  }, /*#__PURE__*/_react["default"].createElement(ProductTitle, {
    color: "gray-dark",
    fontSize: 3,
    fontWeight: 1,
    letterSpacing: "0.5px"
  }, title), /*#__PURE__*/_react["default"].createElement(ProductInfo, null, /*#__PURE__*/_react["default"].createElement(OverflowBox, {
    mt: 1
  }, downloadOptions && /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, null, /*#__PURE__*/_react["default"].createElement(_downloadLinks["default"], {
    downloadAction: downloadAction,
    downloadOptions: downloadOptions,
    downloadText: downloadText,
    showDownloadOptions: true
  })))), date && /*#__PURE__*/_react["default"].createElement(ProductDate, {
    color: "text-light-grey",
    fontWeight: 2,
    letterSpacing: "0.5px",
    my: ["12px", 0],
    width: 1
  }, date));
};

ResultItem.propTypes = propTypes;
ResultItem.displayName = "Modules.ResultItem";
var _default = ResultItem;
exports["default"] = _default;